module.exports = __webpack_public_path__ + "img/SER-A-1-V.7155b313.png";